import { AccountResponse } from '../../../shared/models/account/AccountResponse';
import { Paddle } from '@paddle/paddle-js';

export const showCheckout = (paddle: Paddle, priceId: string, accountResponse: AccountResponse) => {
  paddle.Checkout.open({
    items: [{ priceId, quantity: 1 }],
    customer: {
      ...(accountResponse.addressId && {
        address: { id: accountResponse.addressId },
      }),
      ...(accountResponse.businessId && {
        business: { id: accountResponse.businessId },
      }),
      email: accountResponse.email,
    },
    ...(accountResponse.discountId && {
      discountId: accountResponse.discountId,
    }),
    customData: {
      accountId: accountResponse.accountId,
    },
    settings: {
      locale: accountResponse.language,
      displayMode: 'overlay',
      variant: 'one-page',
    },
  });
};

export const updateCard = (paddle: Paddle, transactionId: string, accountResponse: AccountResponse) => {
  paddle.Checkout.open({
    transactionId,
    customer: {
      address: { id: accountResponse.addressId },
      business: {
        id: accountResponse.businessId,
      },
      email: accountResponse.email,
    },
    customData: {
      accountId: accountResponse.accountId,
      accountType: accountResponse.accountType,
    },
    settings: {
      displayMode: 'overlay',
      variant: 'one-page',
    },
  });
};
